import EditableDropdown from '@/common/EditableDropdown';
import { ILieDropdownOption, ILoftDropdownOption } from './LoftLie';
import { LoftLieHelper } from '@/library';
import styles from './LoftLie.module.scss';

interface IEditLoftLieProps {
  loftOptions: LoftLieHelper.ILoftOptionMap | undefined;
  lieOptions: LoftLieHelper.ILieOptionMap | undefined;
  initialLieId: string;
  initialLoftId: string;
  // eslint-disable-next-line no-unused-vars
  setEditedLie: (option: ILieDropdownOption) => void;
  // eslint-disable-next-line no-unused-vars
  setEditedLoft: (option: ILoftDropdownOption) => void;
}

function EditLoftLie({ loftOptions, lieOptions, initialLieId, initialLoftId, setEditedLie, setEditedLoft }: IEditLoftLieProps) {
  const handleEditedLoft = (id: string) => {
    const loftDropdownOption = loftOptions?.map[id];
    if (!loftDropdownOption) throw new Error('Failed to capture the loft value');
    setEditedLoft(loftDropdownOption);
  };

  const handleEditedLie = (id: string) => {
    const lieDropdownOption = lieOptions?.map[id];
    if (!lieDropdownOption) throw new Error('Failed to capture the lie value');
    setEditedLie(lieDropdownOption);
  };

  if (!lieOptions || !loftOptions) return null;

  return (
    <>
      <EditableDropdown label="Loft" initialId={initialLoftId} options={loftOptions.options} onChange={(id) => handleEditedLoft(id)} className={styles.editableDropdown} />
      <EditableDropdown label="Lie" initialId={initialLieId} options={lieOptions.options} onChange={(id) => handleEditedLie(id)} className={styles.editableDropdown} />
    </>
  );
}

export default EditLoftLie;
